import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Aura from '@primeuix/themes/aura'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'
import '@fontsource/lato/900.css'
import 'primeicons/primeicons.css'
import App from './App.vue'
import { i18n } from './core/i18n'
import { router } from './core/router'
import { useUiStore } from './core/stores/ui'
import { systemSettingsApi } from './modules/identity/systemSettingsApi'
import { setQOneDocumentWebUrl } from './core/qoneDocumentLink'
import './styles/tailwind.css'
import './styles/main.scss'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
useUiStore(pinia).initialize()
app.use(i18n)
app.use(router)
app.use(PrimeVue, {
  ripple: true,
  theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } }
})
app.use(ToastService)
app.use(ConfirmationService)
const notifyUnexpectedError = () => app.config.globalProperties.$toast.add({
  severity: 'error', summary: i18n.global.t('common.error'),
  detail: i18n.global.t('errors.unexpected_action_error'), life: 8000
})
app.config.errorHandler = (error) => { console.error(error); notifyUnexpectedError() }
window.addEventListener('unhandledrejection', notifyUnexpectedError)
app.mount('#app')
// ADR-082: ngôn ngữ mặc định của hệ thống cho người chưa tự chọn (Cài đặt hệ thống › Thông tin chung).
void systemSettingsApi.public().then(({ data }) => {
  if (useUiStore(pinia).applyDefaultLocale(data.defaultLanguage)) i18n.global.locale.value = data.defaultLanguage!
  setQOneDocumentWebUrl(data.qOneDocumentWebUrl)
}).catch(() => {})
